import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

// Component quét QR tái dùng. Gọi onScan(token) khi quét thành công.
// readerId phải là id duy nhất trên trang.
export default function QrScanner({ readerId = "qr-reader", onScan, onError }) {
    const scannerRef = useRef(null);
    const stoppingRef = useRef(false);

    const stop = async () => {
        if (scannerRef.current && !stoppingRef.current) {
            stoppingRef.current = true;
            try { await scannerRef.current.stop(); } catch (e) { /* ignore */ }
            scannerRef.current = null;
            stoppingRef.current = false;
        }
    };

    const extractToken = (text) => {
        const raw = (text || '').trim();
        // 1) URL dạng .../checkin-cho-ngoi?token=xxx
        try {
            if (/^https?:\/\//i.test(raw)) {
                const u = new URL(raw);
                const t = u.searchParams.get('token');
                if (t) return t;
            }
        } catch (e) { /* not a valid url */ }
        // 2) JSON {token}
        try {
            const obj = JSON.parse(raw);
            if (obj && obj.token) return obj.token;
        } catch (e) { /* not json */ }
        // 3) token thô
        return raw;
    };

    useEffect(() => {
        let cancelled = false;
        const init = async () => {
            if (scannerRef.current) return;
            const scanner = new Html5Qrcode(readerId);
            try {
                const devices = await Html5Qrcode.getCameras();
                if (cancelled) return;
                if (devices && devices.length > 0) {
                    await scanner.start(
                        { facingMode: "environment" },
                        { fps: 10, qrbox: 250 },
                        async (decodedText) => {
                            await stop();
                            if (onScan) onScan(extractToken(decodedText));
                        },
                        () => { /* ignore per-frame errors */ }
                    );
                    scannerRef.current = scanner;
                } else if (onError) {
                    onError('Không tìm thấy camera');
                }
            } catch (err) {
                console.error("QR scanner error:", err);
                if (onError) onError('Không mở được camera');
            }
        };
        init();
        return () => { cancelled = true; stop(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [readerId]);

    return <div id={readerId} style={{ width: 320, maxWidth: '100%', margin: '0 auto' }}></div>;
}
